import { connect } from 'react-redux';
import { CommonQuestionList } from '../../components/questions/CommonQuestionList';
import { IApplicationState } from '../../store';
import { ActionCreators as BenchmarksActionCreators } from '../../store/BenchmarksStore';
import { ActionCreators as QuestionListActionCreators } from '../../store/CommonQuestionListActions';
import { ActionCreators as CulturesActionCreators } from '../../store/CulturesStore';

export interface ICommonQuestionListProps {
	parentQuestionId?: number;
}

export const mapStateToProps = (state: IApplicationState, props: ICommonQuestionListProps) => {
	return {
		...props,
		...state.benchmarks,
		...state.clientParticipantAttributes,
		...state.commonQuestionList,
		...state.cultures,
		addedQuestions: state.questionModal.addedQuestions,
		defaultCultureCode: state.survey.surveyEditModel.defaultCultureCode,
		loading: state.commonQuestionList.loading,
		selectedBenchmarkIds: state.survey.surveyEditModel.benchmarks,
		supportedCultures: state.survey.surveyEditModel.supportedCultures,
		surveyId: state.survey.surveyEditModel.survey.surveyId,
	};
};

export const CommonQuestionListContainer: React.ComponentType<ICommonQuestionListProps> = connect(mapStateToProps, {
	...BenchmarksActionCreators,
	...CulturesActionCreators,
	...QuestionListActionCreators,
})(CommonQuestionList as any);
